/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useCallback, useState } from "react";
import { useShowError } from "~/components/Error/useShowError";
import { PDCustomer } from "~/models/pagerDuty";
import { useAxios } from "~/tools";

const usePDCustomers = () => {
  const [customers, setCustomers] = useState<PDCustomer[]>([]);
  const [loading, setLoading] = useState(false);

  const { Axios } = useAxios();
  const { showError } = useShowError();

  const fetchCustomers = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await Axios().get("/mcrp/pagerduty/customersAllRegions");
      setCustomers(data?.customers || []);
    } catch (e: any) {
      showError(e.response);
      setCustomers([]);
    } finally {
      setLoading(false);
    }
  }, [Axios, showError]);

  return { customers, loading, fetchCustomers };
};

export { usePDCustomers };
